export class TenantInvite {
  email: string;
  firstName: string;
  lastName: string;
  role: string;

  static empty() {
    const tenantInvite = new TenantInvite();
    tenantInvite.email = '';
    tenantInvite.firstName = '';
    tenantInvite.lastName = '';
    tenantInvite.role = '';
    return tenantInvite;
  }
}
